import React from 'react';
import PropTypes from 'prop-types';

import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { CONDITIONS, KEYS } from '../utils/constants';
import { useOfferings } from '../utils/useOfferings';

import PregnancyIndex from '../PregnancyIndex';
import PostpartumIndex from '../PostpartumIndex';
import PainIndex from '../PainIndex';

const OfferingIndex = ({ userId, path, queryEmail }) => {
  const [selectedPath] = useLocalStorage(KEYS.PATH);
  const { offeringList, selectedOffer, setSelectedOffer, isDiscount, currentIdentifier } = useOfferings(userId);

  switch (path || selectedPath) {
    case CONDITIONS.PREGNANCY:
      return (
        <PregnancyIndex
          offerings={offeringList}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
          path={path}
          isDiscount={isDiscount}
          identifier={currentIdentifier}
          queryEmail={queryEmail}
        />
      );
    case CONDITIONS.POSTPARTUM:
      return (
        <PostpartumIndex
          offerings={offeringList}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
          path={path}
          isDiscount={isDiscount}
          identifier={currentIdentifier}
          queryEmail={queryEmail}
        />
      );
    case CONDITIONS.INCONTINENCE:
    case CONDITIONS.SEXUAL:
      return (
        <PainIndex
          offerings={offeringList}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
          path={path}
          isDiscount={isDiscount}
          identifier={currentIdentifier}
          queryEmail={queryEmail}
        />
      );
    default:
      return null;
  }
};

OfferingIndex.defaultProps = {
  userId: null,
  path: null,
  queryEmail: '',
};

OfferingIndex.propTypes = {
  userId: PropTypes.string,
  path: PropTypes.string,
  queryEmail: PropTypes.string,
};

export default OfferingIndex;
